module.exports = __webpack_public_path__ + "static/img/answer-questionnaire1.0ceaae8.png";